export default __webpack_public_path__ + "static/media/pms_menubar.e5237503.png";